module.exports = __webpack_public_path__ + "static/img/5.0d87c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/5.png
// module id = S6iw
// module chunks = 1